module.exports = __webpack_public_path__ + "img/LOGO_IMSS.5a76cdb8.png";